import React, { useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Box, Checkbox, Tooltip } from '@mui/material'

import { useAjaxContext } from '../../../../core/ajax/contexts'
import { ConfirmationDialog, useModalContext } from '../../../../ui'
import feedback from '../../../../core/feedback'
import { useLoaderBasic } from '../../../loader/hooks'
import { useStuckCalls } from '../../hooks/stuck-calls.hook'

const ERROR_NO_ENVIABLE = 4205

export const SendToZeusCheckbox = ({ rowData, row, cell, ...props }) => {
  const { getStuck } = useStuckCalls()
  const { formatMessage } = useIntl()
  const { putById } = useAjaxContext()
  const {
    actions: { open },
  } = useModalContext()
  const {
    state: { config },
    loadData,
  } = useLoaderBasic({ identifier: 'stuck', call: getStuck })
  const [checked, setChecked] = useState(false)
  const [disabled, setDisabled] = useState(true)

  const application = rowData || row?.original || {}

  useEffect(() => {
    setChecked(application?.enviable !== 'unchecked')
    setDisabled(application?.enviable === 'disabled' || application?.enviable === 'forbbiden')
  }, [application?.enviable, application?.scr_id])

  const postCheckEnviarScr = useCallback(
    (application, checked) => {
      if (!application || !application.scr_id) {
        feedback('error', 'Datos de aplicación no válidos')
        return
      }
      const payload = { enviar_scr: checked }
      putById('/scr/check_enviar_scr', application.scr_id, payload)
        .then((response) => {
          loadData(config)
        })
        .catch(({ response }) => {
          if (response.data?.code === ERROR_NO_ENVIABLE) {
            return feedback('error', 'Esta petición no puede ser enviada a ZEUS')
          }
          feedback('error', 'Error desconocido.')
        })
    },
    [config, loadData, putById]
  )

  if (!application || typeof application !== 'object' || !application.scr_id) {
    return (
      <Box display="flex" style={{ justifyContent: 'center', width: '100%' }} mt={1} mb={1}>
        <span>--</span>
      </Box>
    )
  }

  const checkbox_tooltip = () => {
    if (application?.enviable === 'disabled') {
      return 'La solicitud está siendo enviada'
    } else if (application?.enviable === 'forbbiden') {
      return 'La solicitud no puede ser enviada a ZEUS'
    } else {
      return ''
    }
  }

  const openModalCheckSentToZeus = (e) => {
    const isChecked = e.target.checked
    const TXT_ROOT = 'pages.application.detail.modal.checkboxSentToZeus.'
    open({
      Component: ConfirmationDialog,
      data: {
        title: formatMessage({ id: TXT_ROOT + 'title' }),
        text: formatMessage({ id: TXT_ROOT + 'text.' + (isChecked ? '1' : '2') }),
        yesText: formatMessage({ id: TXT_ROOT + 'yes' }),
        noText: formatMessage({ id: TXT_ROOT + 'no' }),
        yesAction: () => postCheckEnviarScr(application, isChecked),
      },
      type: 'centered',
    })
  }

  return (
    <Box display="flex" style={{ justifyContent: 'center', width: '100%' }} mt={1} mb={1}>
      {disabled ? (
        <Tooltip title={checkbox_tooltip()} arrow>
          <div>
            <Checkbox color="primary" checked={checked} disabled={true} />
          </div>
        </Tooltip>
      ) : (
        <div>
          <Checkbox color="primary" checked={checked} onChange={openModalCheckSentToZeus} />
        </div>
      )}
    </Box>
  )
}
